module.exports = __webpack_public_path__ + "static/panama-3-c567f9d5f1ec4074d4abcbee4160f6ed.jpg";